import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">The Catholic Church in China</p>
        <h1>Catholic China</h1>
        <p className="lede">
          News, context, and history for Catholics in China and those following the Church there. Catholics make up roughly 0.7% of China's population, spread across more than 150 dioceses and apostolic prefectures with no Vatican-recognized bishops' conference.
        </p>
        <div className="cta-row">
          <a href="#structure">
            Church Structure
          </a>
          <a href="#history" className="secondary">
            History
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Church Structure</h2>
          <p>
            China's Catholic Church spans 21 ecclesiastical provinces, 21 metropolitan archdioceses, 101 suffragan dioceses, 28 apostolic prefectures, and the exempt Diocese of Macau -- over 150 jurisdictions in total, without an officially recognized national bishops' conference.
          </p>
        </article>
        <article>
          <h2>A Complicated History</h2>
          <p>
            Formal diplomatic relations between China and the Vatican ended in 1949. Since then, Catholic life in China has continued through both state-sanctioned and unofficial structures, a divide that still shapes parish life today.
          </p>
        </article>
        <article>
          <h2>A Small but Real Presence</h2>
          <p>
            Catholics remain a small minority nationally, but individual dioceses report real, tracked congregations -- for example, the Diocese of Zhangjiakou counted about 85,000 Catholics as of 2025.
          </p>
        </article>
      </section>

      <section className="section" id="structure">
        <h2>Major Archdioceses & Cathedrals</h2>
        <p className="section-sub">China has over 150 Catholic jurisdictions without an officially recognized national bishops' conference; these are among its best-known.</p>
        <div className="directory-list">
          <article className="directory-item">
            <h3>Archdiocese of Beijing</h3>
            <p>Immaculate Conception Cathedral / Wangfujing Cathedral</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Shanghai</h3>
            <p>St. Ignatius Cathedral</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Guangzhou</h3>
            <p>Sacred Heart Cathedral</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Chongqing</h3>
            <p>St. Joseph's Cathedral</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Hangzhou</h3>
            <p>Cathedral of the Immaculate Conception</p>
          </article>
          <article className="directory-item">
            <h3>Archdiocese of Fuzhou</h3>
            <p>Cathedral of St. Dominic</p>
          </article>
        </div>
      </section>

      <section className="section" id="news">
        <h2>Latest News</h2>
        <p className="section-sub">Recent, sourced developments -- updated as new stories are verified.</p>
        <div className="news-list">
          <article className="news-item">
            <p className="news-date">2025</p>
            <h3>Diocese of Zhangjiakou reports steady congregation</h3>
            <p>Zhangjiakou counted approximately 85,000 Catholics as of 2025, one of the larger tracked diocesan populations in northern China.</p>
            <p className="news-source">Source: Catholic-Hierarchy.org</p>
          </article>
          <article className="news-item">
            <p className="news-date">Ongoing</p>
            <h3>China-Vatican relations remain formally unresolved</h3>
            <p>Diplomatic relations between China and the Holy See have remained severed since 1949, with Catholic life continuing through both state-sanctioned and unofficial Church structures.</p>
            <p className="news-source">Source: Wikipedia (Catholic Church in China)</p>
          </article>
        </div>
      </section>
    </div>
  );
}

export default App;
